import React, { useState } from "react";
import { ListGroup, Image, Collapse } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import {
  FiActivity,
  FiAlertTriangle,
  FiBarChart2,
  FiUpload,
  FiChevronDown,
  FiChevronRight,
  FiArrowLeft,
  FiTool,
  FiPackage,
  FiShield,
  FiClock,
  FiFileText,
  FiUsers,
} from "react-icons/fi";
import Logout from "../assets/logout.svg";
import Logo from "../assets/logo.svg";
import { useAuth } from "../context/AuthProvider";

const AdminSidebar = ({ isOpen, onClose }) => {
  const location = useLocation();
  const { logout } = useAuth();
  const [observabilityOpen, setObservabilityOpen] = useState(true);
  const [toolsOpen, setToolsOpen] = useState(true);

  const sections = [
    {
      label: "Observability",
      icon: <FiActivity className="fs-20" />,
      open: observabilityOpen,
      toggle: () => setObservabilityOpen(!observabilityOpen),
      children: [
        {
          path: "/admin/health",
          icon: <FiActivity className="fs-18" />,
          label: "Monitor Health",
          match: (path) => path.startsWith("/admin/health"),
        },
        {
          path: "/admin/alerts",
          icon: <FiAlertTriangle className="fs-18" />,
          label: "Alerts",
          match: (path) => path === "/admin/alerts",
        },
        {
          path: "/admin/bandwidth",
          icon: <FiBarChart2 className="fs-18" />,
          label: "Bandwidth & Cost",
          match: (path) => path === "/admin/bandwidth",
        },
        {
          path: "/admin/stale",
          icon: <FiClock className="fs-18" />,
          label: "Stale Monitors",
          match: (path) => path === "/admin/stale",
        },
        {
          path: "/admin/logs",
          icon: <FiFileText className="fs-18" />,
          label: "Logs",
          match: (path) => path.startsWith("/admin/logs"),
        },
      ],
    },
    {
      label: "Tools",
      icon: <FiTool className="fs-20" />,
      open: toolsOpen,
      toggle: () => setToolsOpen(!toolsOpen),
      children: [
        {
          path: "/admin/clients",
          icon: <FiUsers className="fs-18" />,
          label: "Clients",
          match: (path) => path === "/admin/clients",
        },
        {
          path: "/admin/runtime",
          icon: <FiShield className="fs-18" />,
          label: "Runtime Validation",
          match: (path) => path === "/admin/runtime",
        },
        {
          path: "/admin/proxies",
          icon: <FiUpload className="fs-18" />,
          label: "Upload Proxies",
          match: (path) => path === "/admin/proxies",
        },
        {
          path: "/admin/products",
          icon: <FiPackage className="fs-18" />,
          label: "Products",
          match: (path) => path === "/admin/products",
        },
      ],
    },
  ];

  return (
    <div className={`sidebar d-flex flex-column justify-content-between ${isOpen ? "open" : ""}`}>
      <div className="d-flex flex-column">
        <div className="logo-container">
          <Image src={Logo} className="logo object-fit-cover" alt="logo" />
        </div>
        <div className="p-3">
          <ListGroup className="nav pt-1 ps-0" as="ul">
            {sections.map((section, index) => (
              <React.Fragment key={`section-${index}`}>
                <ListGroup.Item
                  className="border-0 rounded-3 bg-transparent text-gray-2 fw-500"
                  as="li"
                >
                  <div
                    className="d-flex align-items-center justify-content-between gap-2 fs-14 text-gray-2 fw-500"
                    onClick={section.toggle}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="d-flex align-items-center gap-2">
                      {section.icon} {section.label}
                    </div>
                    {section.open ? (
                      <FiChevronDown className="fs-16" />
                    ) : (
                      <FiChevronRight className="fs-16" />
                    )}
                  </div>
                </ListGroup.Item>

                <Collapse in={section.open}>
                  <div>
                    {section.children.map((child) => {
                      const isActive = child.match(location.pathname);
                      return (
                        <ListGroup.Item
                          key={child.path}
                          className={`border-0 rounded-3 ms-4 ${
                            isActive
                              ? "bg-white-12 text-gray fw-600"
                              : "bg-transparent text-gray-2 fw-500"
                          }`}
                          as="li"
                        >
                          <Link
                            to={child.path}
                            onClick={onClose}
                            className={`text-nowrap d-flex align-items-center gap-2 fs-13 text-decoration-none ${
                              isActive
                                ? "text-gray fw-600"
                                : "text-gray-2 fw-500"
                            }`}
                          >
                            {child.icon} {child.label}
                          </Link>
                        </ListGroup.Item>
                      );
                    })}
                  </div>
                </Collapse>
              </React.Fragment>
            ))}
          </ListGroup>
        </div>
      </div>

      <div className="mx-3 mb-3 d-flex flex-column gap-2">
        <Link
          to="/"
          onClick={onClose}
          className="btn btn-outline-secondary w-100 rounded-3 py-2 px-3 fw-600 fs-14 d-flex align-items-center justify-content-center gap-2 text-gray-2 text-decoration-none"
        >
          <FiArrowLeft />
          Back to Dashboard
        </Link>
        <button
          onClick={(e) => {
            e.preventDefault();
            logout();
          }}
          className="btn btn-secondary w-100 rounded-3 py-2 px-3 fw-600 fs-14 d-flex align-items-center justify-content-center gap-2"
        >
          <Image src={Logout} className="object-fit-cover" alt="logout" />
          Logout
        </button>
      </div>
    </div>
  );
};

export default AdminSidebar;
